/* eslint-disable no-undef */

export function setStorage<T>(name: string, data: T): void {
  if (typeof window !== "undefined") {
    window.localStorage.setItem(name, JSON.stringify(data))
  }
}

export function getStorage(name: string): any {
  if (typeof window !== "undefined") {
    const val = window.localStorage[name]
    return val === undefined ? {} : JSON.parse(val)
  }
}
